import Select from '@blocks/Select'
import React from 'react'
import { useTrackingFormContext } from '../context'

export default function TrackingParticipation(participation: Props) {
    const { awards } = useTrackingFormContext()

    const award = participation.award 
        ? awards?.find(item => parseInt(item.value) === participation.id) 
        : undefined
        
    return <Select required id={`${participation.id}`} isClearable name="participations[]" value={award} options={awards} />
}

type Props = PartialExcept<Admin.Resources.ParticipationTracking, "id">